import React from 'react';
import { TextField } from '@mui/material';

const MessageInput = ({ value, onChange, placeholder, disabled, rows = 1 }) => {
  return (
    <TextField
      multiline
      rows={rows}
      fullWidth
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      sx={{ 
        wordBreak: "break-word", 
        whiteSpace: "pre-wrap",
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'white',
        }
      }}
    />
  );
};

export default MessageInput; 